import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function HookSection() {
  return <section className="py-20 px-4 bg-[#FFF0E6]" data-id="element-63">
      <div className="max-w-3xl mx-auto" data-id="element-64">
        <FadeIn data-id="element-65">
          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-sm border border-[#2D2A26]/5 relative" data-id="element-66">
            <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-[#F5A623] text-white px-6 py-2 rounded-full font-serif font-bold text-lg shadow-md" data-id="element-67">
              Sé cómo se siente.
            </div>

            <p className="font-sans text-lg md:text-xl text-[#2D2A26] leading-relaxed mt-4 space-y-6" data-id="element-68">
              <span className="block" data-id="element-69">
                Llegas a las 7:00 PM con la paciencia al límite, pides que se
                laven los dientes y nadie se mueve. Lo pides otra vez. Nada.
              </span>

              <span className="block" data-id="element-70">
                A la quinta vez, el calor sube por tu pecho, pierdes el control
                y terminas gritando. Logras que lo hagan, pero te queda ese nudo
                en el estómago:{' '}
                <strong className="font-semibold text-[#E8604C]" data-id="element-71">
                  la culpa de haber explotado otra vez.
                </strong>
              </span>

              <span className="block italic text-[#2D2A26]/80" data-id="element-72">
                Ese ciclo de "ignorar → repetir → gritar → arrepentirse" no se
                rompe con más castigos, se rompe con un plan diferente.
              </span>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}